import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import getInitials from '@/utils/getInitials';
import getAvatarColor from '@/utils/getAvatarColor';

const UserAvatar = ({
	showNameBelow = true,
	showName = true,
	avatarWidth,
	avatarHeight,
	avatarFontSize,
	nameFontSize,
	fontWeightThin = false,
	avatarBgColor,
	user, // the user object
	marginTop,
	marginLeft,
	onlineIndicatorHeight = '0.75rem',
	onlineIndicatorWidth = '0.75rem',
}) => {
	if (!user) {
		return null;
	}

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: showNameBelow ? 'column' : 'row',
				width: avatarWidth,
				height: avatarHeight,
				alignItems: 'center',
				marginTop: marginTop,
				marginLeft: marginLeft,
			}}
		>
			<span className="relative inline-flex m-0">
				<div className="relative flex items-center justify-center">
					<Avatar
						key={user._id}
						style={{
							width: `${avatarWidth}`,
							height: `${avatarHeight}`,
							fontSize: `${avatarFontSize}`,
							backgroundColor: `${avatarBgColor}`,
						}}
					>
						{user.profilePictureUrl ? (
							<AvatarImage
								src={user.profilePictureUrl}
								alt="profile-picture"
							/>
						) : (
							// coloured initials, as the inbox shows customers
							<AvatarFallback
								className="font-medium text-white"
								style={{
									backgroundColor: getAvatarColor(
										user?.name || user?._id
									),
								}}
							>
								{getInitials(user?.name)}
							</AvatarFallback>
						)}
					</Avatar>
				</div>
				<span
					style={{
						right: '14%',
						bottom: '14%',
						transform: 'scale(1) translate(50%, 50%)',
						transformOrigin: '100% 100%',
						height: onlineIndicatorHeight,
						width: onlineIndicatorWidth,
					}}
					className={cn(
						'absolute flex rounded-full',
						user.isOnline
							? 'bg-emerald-500 ring-2 ring-background'
							: 'bg-transparent'
					)}
				/>
			</span>
			{showName ? (
				<p
					style={{
						fontSize: `${nameFontSize}`,
						fontWeight: fontWeightThin ? 'normal' : '700',
						marginLeft: showNameBelow && showName ? '' : 5,
					}}
					className="text-center items-center flex"
				>
					{user.name.split(' ')[0]}
				</p>
			) : null}
		</div>
	);
};

export default UserAvatar;
